export const compareByCreationTimestamp = <
  T extends { createdAt: string | Date },
>(
  a: T,
  b: T,
) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
